var HEY_LISTEN = 'Hey, listen! ';
var warning = function () { };
var invariant = function () { };
if (process.env.NODE_ENV !== 'production') {
    warning = function (check, message) {
        if (!check && typeof console !== 'undefined') {
            console.warn(HEY_LISTEN + message);
        }
    };
    invariant = function (check, message) {
        if (!check) {
            throw new Error(HEY_LISTEN.toUpperCase() + message);
        }
    };
}

export { warning, invariant };



//////////////////
// WEBPACK FOOTER
// ./node_modules/hey-listen/dist/hey-listen.es.js
// module id = 70
// module chunks = 0